<template>
  <div id="app">

    <home/>
  </div>
</template>

<script>
import Home from './components/home'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
#app {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  margin: 60px;
}

@media (min-width: 320px) {
  #app {
    margin: 60px 20px;
  }
}
</style>
